// frontend/src/components/cardOnFile/cardOnFileBrand.js

/**
 * The calm "Medallion" language the trial strip and the save-card offer card
 * share (owner, ROUND 4): white and pastel grounds, a NAVY action, teal only
 * as an accent. Never the terracotta "attention" paint - the owner rejected it
 * for every card-on-file surface.
 *
 * Brand values from brand/tokens.json, as the navbar already imports them.
 */
export const BRAND = Object.freeze({
  navy: "#0E1628",
  navyHover: "#1B2740",
  slate: "#5E7378",
  motto: "#3D6F7A", // 5.6:1 on white - the one teal that may carry text
  ringBright: "#B9E3DB",
  mintGround: "#F3FAF8",
  mintRule: "#D7ECE7",
  washMint: "#D3F0EA",
  washBlush: "#F7D7E4",
  hairline: "rgba(14, 22, 40, 0.08)",
});

/** The focus ring every card-on-file control wears. */
export const focusRingSx = Object.freeze({
  "&:focus-visible": {
    outline: `2px solid ${BRAND.navy}`,
    outlineOffset: 3,
  },
});

/** The solid navy pill (strip button, offer-card button). */
export const navyPillSx = Object.freeze({
  borderRadius: "999px",
  border: "none",
  background: BRAND.navy,
  color: "#FFFFFF",
  cursor: "pointer",
  fontWeight: 600,
  whiteSpace: "nowrap",
  boxShadow: "0 4px 12px rgba(14, 22, 40, 0.16)",
  transition: "background-color 0.2s ease, box-shadow 0.2s ease",
  "@media (hover: hover)": {
    "&:hover": { background: BRAND.navyHover, boxShadow: "0 6px 16px rgba(14, 22, 40, 0.2)" },
  },
  ...focusRingSx,
});

/**
 * The white capsule of the calm dashboard bands (the trial strip, the
 * failed-first-charge banner): a pill on sm+, a softer card at xs.
 */
export const bandCapsuleSx = Object.freeze({
  maxWidth: "100%",
  boxSizing: "border-box",
  borderRadius: { xs: "22px", sm: "999px" },
  background: "#FFFFFF",
  border: `1px solid ${BRAND.hairline}`,
  boxShadow: "0 10px 30px rgba(14, 22, 40, 0.07), 0 2px 6px rgba(14, 22, 40, 0.04)",
});

/**
 * The one desktop width (sm+) the dashboard's trial strip and the phone ask
 * card share (owner, phone-ask design round): the strip grows to at least
 * this (it still hugs a longer sentence), the card is capped at it, so the
 * two read as one family. Phones: both full width.
 */
export const DASHBOARD_BAND_WIDTH = 560;

/**
 * Where a dashboard band sits (owner, ROUND 6): a little closer to the navbar
 * than the dashboard's top padding (it is the first thing in the content), and
 * a little more room before the KPI cards than before the offer card it opens.
 *
 * @param {boolean} [beforeCard]  the offer card follows the band
 * @returns {object} sx
 */
export const bandSpacingSx = (beforeCard = false) => ({
  mt: -1.5,
  mb: beforeCard ? 2 : { xs: 3, sm: 3.5 },
});
